<vi-page [sidenavs]="false" [footer]="false">
  <vi-content body [fluid]="true" direction="row" layoutAlign="justify-center items-start">
    <app-home-installer main content></app-home-installer>
  </vi-content>
</vi-page>
